"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonClickDispatch = buttonClickDispatch;
exports.linkClickDispatch = linkClickDispatch;
exports.interactionEventDispatch = interactionEventDispatch;

var Actions = _interopRequireWildcard(require("./actions"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * fetches requests
 * @returns {thunk} puts returned requests in state
 */
function buttonClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackButtonClick(payload));
  };
}

function linkClickDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackLinkClick(payload));
  };
}

function interactionEventDispatch(payload) {
  return function (dispatch) {
    return dispatch(Actions.trackInteractionEvent(payload));
  };
}


//////////////////
// WEBPACK FOOTER
// ./lib/analytics/modules/AnalyticsModule.js
// module id = 16
// module chunks = 0